class StatusAlteracaoEnum {
  constructor() {
    this.status = {
      AGUARDANDO: 'AGUARDANDO',
      FINALIZADO: 'FINALIZADO',
      CANCELADO: 'CANCELADO',
    };
  }

  getValues() {
    return ['AGUARDANDO', 'FINALIZADO', 'CANCELADO'];
  }

  getValue(status) {
    return this.getValues().find(statusAlteracao => statusAlteracao === status);
  }
}

export default new StatusAlteracaoEnum();
